import { combineReducers } from 'redux';
import UserSession from '../reducers//session';

const reducers = {
    UserSession
};

export default combineReducers({  ...reducers });
